import React, { useState } from "react";
import { Container, Table, Button, Form, Row, Col } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import MainScreen from "../../components/MainScreen";
import "./Paginated2.css";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from "../../features/userSlice";

const transformEntityCodes = (records) => {
  return records.map(row => {
    const updatedRow = { ...row };
    if ((updatedRow.Company_Code || '').toUpperCase() === 'SP') {
      updatedRow.Company_Code = 'SE';
    }
    return updatedRow;
  });
};

const SalaryJvUpload = () => {

  const [file, setFile] = useState(null);
  const [records, setRecords] = useState([]);
  const [entityCode, setEntityCode] = useState("");
  const [salaryMonth, setSalaryMonth] = useState("");
  const [jvType, setJvType] = useState("N");
  const [summary, setSummary] = useState({ debit: 0, credit: 0 });
  const [jvNumber, setJvNumber] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [existingJvList, setExistingJvList] = useState([]);

  const navigate = useNavigate();
  const user = useSelector(selectUser);
  const token = user?.token;
  const emp_id = user?.emp_id;

  const allowedFields = [
    "Company_Code",
    "Division_Code",
    "CostCenter_Code",
    "GLCodeName",
    "Debit",
    "Credit",
    "Particular"
  ];

  /*
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setRecords([]);
    setJvNumber(null);
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        let data = XLSX.utils.sheet_to_json(ws);

        data = data.filter(row => {
          const debit = parseFloat(row.Debit || 0);
          const credit = parseFloat(row.Credit || 0);
          return !(debit === 0 && credit === 0);
        });

        const invalidRow = data.find(row => (row.Company_Code || '').toUpperCase() !== entityCode.toUpperCase());
        if (invalidRow) {
          alert(`Entity Code mismatch in row: ${JSON.stringify(invalidRow)}`);
          return;
        }

        data = data.map(row => {
          const filtered = {};
          allowedFields.forEach(field => {
            filtered[field] = row[field] || "";
          });
          return filtered;
        });

        setRecords(data);

        const totalDebit = data.reduce((sum, row) => sum + Number(row.Debit || 0), 0);
        const totalCredit = data.reduce((sum, row) => sum + Number(row.Credit || 0), 0);
        setSummary({ debit: totalDebit, credit: totalCredit });
      };
      reader.readAsBinaryString(selectedFile);
    }
  };
  */
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setRecords([]);
    setJvNumber(null);

    if (!entityCode || !salaryMonth) {
      alert("Please select Entity Code and Salary Month first.");
      return;
    }

  
    if (selectedFile) {
      const fileName = selectedFile.name;
      /*
      const entityFileSuffix = {
        SE: "_Singhal.csv",
        SS: "_Shyam.csv",
        SP: "_Salasary.csv"
      };
      const expectedSuffix = entityFileSuffix[entityCode];
      if (expectedSuffix && !fileName.endsWith(expectedSuffix)) {
        alert(`❌ File name should end with ${expectedSuffix} for entity ${entityCode}`);
        return;
      }
      */

      const monthText = new Date(`${salaryMonth}-01`).toLocaleDateString("en-US", { month: "short", year: "numeric" }).toUpperCase().replace(" ", "-");
      const shortMonth = new Date(`${salaryMonth}-01`).toLocaleDateString("en-US", { month: "short" }).toUpperCase();
      const fullYear = new Date(`${salaryMonth}-01`).getFullYear();

      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        let data = XLSX.utils.sheet_to_json(ws);

        data = data.filter(row => {
          const debit = parseFloat(row.Debit || 0);
          const credit = parseFloat(row.Credit || 0);
          return !(debit === 0 && credit === 0);
        });

        const invalidRow = data.find(row => (row.Company_Code || '').toUpperCase() !== entityCode.toUpperCase());
        if (invalidRow) {
          alert(`❌ Entity Code mismatch in row: ${JSON.stringify(invalidRow)}`);
          return;
        }

        const monthMismatch = data.find(row => {
          const text = (row.Particular || "").toUpperCase();
          return !text.includes(monthText);
        });
        if (monthMismatch) {
          alert(`❌ Month mismatch in Particular column for row: ${JSON.stringify(monthMismatch)}`);
          return;
        }

        data = data.map(row => {
          const filtered = {};
          allowedFields.forEach(field => {
            filtered[field] = row[field] || "";
          });
          return filtered;
        });

        setRecords(data);

        const totalDebit = data.reduce((sum, row) => sum + Number(row.Debit || 0), 0);
        const totalCredit = data.reduce((sum, row) => sum + Number(row.Credit || 0), 0);
        setSummary({ debit: totalDebit, credit: totalCredit });
      };
      reader.readAsBinaryString(selectedFile);
    }
  };

  const validateBeforeSubmit = async () => {
    const monthText = new Date(`${salaryMonth}-01`).toLocaleDateString("en-US", {
      month: "short",
      year: "numeric",
    }).toUpperCase().replace(" ", "-");
  
    // Frontend validations
    const invalidRow = records.find(row => (row.Company_Code || '').toUpperCase() !== entityCode.toUpperCase());
    if (invalidRow) {
      alert(`❌ Entity Code mismatch in data row: ${JSON.stringify(invalidRow)}`);
      return false;
    }
  
    const monthMismatch = records.find(row => {
      const text = (row.Particular || "").toUpperCase();
      return !text.includes(monthText);
    });
    if (monthMismatch) {
      alert(`❌ Month mismatch in Particular column for row: ${JSON.stringify(monthMismatch)}`);
      return false;
    }
  
    // Call backend to check if JV already exists
    try {
      const response = await axios.post("/api/salaryJv/checkPostedSalaryJv", {
        salary_month: salaryMonth,
        hr_jv_type: jvType,
        hr_entity_code: entityCode
      });
  
      if (response.data.exists) {
        alert(`❗${response.data.message}`);
        return false;
      }
    } catch (error) {
      console.error("❌ Error checking JV status:", error);
      alert("Error checking JV status. Please try again.");
      return false;
    }
  
    return true;
  };
    
  const handleSubmit = async () => {

    const isValid = await validateBeforeSubmit();
    if (!isValid) return;
  
    if (!entityCode || !salaryMonth || !jvType) {
      alert("Please fill all inputs before submitting.");
      return;
    }
    if (records.length === 0) {
      alert("No records to submit.");
      return;
    }

    const transformedRecords = transformEntityCodes(records);

    try {
      const payload = {
        rows: transformedRecords,
        user_code: emp_id,
        salary_month: salaryMonth,
        jv_type: jvType,
        hr_entity_code: entityCode,
      };
      const response = await axios.post("/api/salaryjv/upload", payload);
      if (response.data?.success) {
        setJvNumber(response.data.jv_number);
        alert("JV generated successfully");
      } else {
        alert(response.data.message || "Error generating JV");
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("Server error during JV generation");
    }
  };

  const handleShowExistingJV = async () => {
    if (!salaryMonth) {
      alert("Please select Salary Month to view existing JV.");
      return;
    }
    try {
      const response = await axios.post("/api/salaryJv/getPostedSalaryJvDetails", {
        salary_month: salaryMonth
      });
      setExistingJvList(response.data || []);
    } catch (err) {
      console.error("Error fetching JV details:", err);
      alert("Failed to fetch JV details.");
    }
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = records.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(records.length / rowsPerPage);

  if (!token) {
    return (
      <div>
        <p>You must be logged in to print daily attendance.</p>
        <button onClick={() => navigate("/")}>Go to Login</button>
      </div>
    );
  }

  return (
    <Container className="mt-3 paginated-table" style={{ fontSize: "0.68rem" }}>
      <h6 style={{ fontSize: "0.76rem" }}>Salary JV Upload</h6>

      <Row className="mb-2" style={{ fontSize: "0.68rem" }}>
        <Col md={3}>
          <Form.Label style={{ fontSize: "0.68rem", marginBottom: "2px" }}>Entity Code</Form.Label>
          <Form.Select size="sm" style={{ height: "26px", fontSize: "0.68rem" }} value={entityCode} onChange={(e) => setEntityCode(e.target.value)}>
            <option value="">-- Select --</option>
            <option value="SE">SE - Singhal Steel and Power Pvt Ltd (Taraimal Unit)</option>
            <option value="SP">SE - Singhal Steel and Power Pvt Ltd (Gerwani Unit)</option>
            <option value="SS">SS - Shyam ISAP Pvt Ltd</option>
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Label style={{ fontSize: "0.68rem", marginBottom: "2px" }}>Salary Month</Form.Label>
          <Form.Control size="sm" style={{ height: "26px", fontSize: "0.68rem" }} type="month" value={salaryMonth} onChange={(e) => setSalaryMonth(e.target.value)} />
        </Col>
        <Col md={3}>
          <Form.Label style={{ fontSize: "0.68rem", marginBottom: "2px" }}>JV Type</Form.Label>
          <Form.Select size="sm" style={{ height: "26px", fontSize: "0.68rem" }} value={jvType} onChange={(e) => setJvType(e.target.value)}>
            <option value="N">Normal JV</option>
            <option value="F">F&F JV</option>
          </Form.Select>
        </Col>
        <Col md={3}>
          <Form.Label style={{ fontSize: "0.68rem", marginBottom: "2px" }}>Upload File</Form.Label>
          <Form.Control size="sm" style={{ height: "26px", fontSize: "0.68rem" }} type="file" accept=".xlsx,.xls,.csv" onChange={handleFileChange} />
        </Col>
      </Row>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <Button
          variant="info"
          size="sm"
          style={{ height: "28px", fontSize: "0.68rem" }}
          onClick={handleShowExistingJV}
        >
          Show Existing JV
        </Button>

        <Button
          variant="success"
          size="sm"
          style={{ height: "28px", fontSize: "0.68rem" }}
          onClick={handleSubmit}
          disabled={
            summary.debit.toFixed(2) !== summary.credit.toFixed(2) ||
            !entityCode ||
            !salaryMonth ||
            !jvType ||
            records.length === 0
          }
        >
          Generate JV
        </Button>
      </div>

      {records.length > 0 && (
        <>
          <div className="p-1 rounded bg-warning text-dark fw-bold mb-2" style={{ fontSize: "0.68rem" }}>
            Records: {records.length} | Total Debit: {summary.debit.toFixed(2)} | Total Credit: {summary.credit.toFixed(2)}
          </div>

          <Table striped bordered size="sm" responsive className="table" style={{ fontSize: "0.66rem" }}>
            <thead>
              <tr>
                {allowedFields.map((key, idx) => (
                  <th key={idx}>{key}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentRows.map((row, rowIndex) => (
                <tr key={rowIndex} style={{ height: "24px" }}>
                  {allowedFields.map((key, idx) => (
                    <td key={idx}>{row[key]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="pagination-container mt-1" style={{ fontSize: "0.66rem" }}>
            <div className="pagination-controls">
              <div className="pagination-buttons align-items-center" style={{ display: "flex", gap: "10px" }}>
                <Button size="sm" style={{ height: "18px", fontSize: "0.66rem" }} onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1}>
                  Previous
                </Button>
                <span style={{ paddingTop: "0", fontSize: "0.66rem", lineHeight: "1.2" }}>
                  Page {currentPage} of {totalPages}
                </span>
                <Button size="sm" style={{ height: "18px", fontSize: "0.66rem" }}
                  onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                  disabled={currentPage === totalPages}
                >
                  Next
                </Button>
                <Form.Select size="sm" style={{ width: "80px", fontSize: "0.66rem", height: "18px" }} value={rowsPerPage} onChange={(e) => setRowsPerPage(Number(e.target.value))}>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </>
      )}

      {existingJvList.length > 0 && (
        <div className="mt-4">
          <h6 style={{ fontSize: "0.72rem" }}>Existing JV Records</h6>
          <Table striped bordered size="sm" responsive style={{ fontSize: "0.66rem" }}>
            <thead>
              <tr>
                <th>HR Entity</th>
                <th>HR Month</th>
                <th>JV Type</th>
                <th>Entity</th>
                <th>TCode</th>
                <th>VR No</th>
              </tr>
            </thead>
            <tbody>
              {existingJvList.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.HR_ENTITY_CODE}</td>
                  <td>{new Date(item.HR_MONTH).toLocaleDateString('en-GB', { year: 'numeric', month: 'short' })}</td>
                  <td>{item.HR_JV_TYPE}</td>
                  <td>{item.ENTITY_CODE}</td>
                  <td>{item.TCODE}</td>
                  <td>{item.VRNO}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}

      {jvNumber && (
        <div className="mt-3 alert alert-success" style={{ fontSize: "0.75rem" }}>
          ✅ JV Generated Successfully: <strong>{jvNumber}</strong>
        </div>
      )}
    </Container>
  );
};

export default SalaryJvUpload;
